import { Injectable } from '@angular/core';
import {proyecto} from "../models/proyecto";
import {plano} from "../models/plano";
import {zona} from "../models/zona";
import {luminaria} from "../models/luminaria";
import {LuminariaService} from "./luminaria.service";

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private selectedProyecto: proyecto;
  private selectedPlano: plano;
  private selectedZona: zona;
  private selectedLuminaria: luminaria;

  constructor(public luminariaService: LuminariaService) { }

  checkSelected() {
    if (this.selectedProyecto) {
      return 0;
    } else if (this.selectedPlano) {
      return 1;
    } else if (this.selectedZona) {
      return 2;
    } else if (this.selectedLuminaria) {
      return 3;
    } else {
      return -1;
    }
  }

  nothingSelect() {
    this.selectedProyecto = null;
    this.selectedPlano = null;
    this.selectedZona = null;
    this.selectedLuminaria = null;
  }

  getSelectedProyecto() {
    return this.selectedProyecto;
  }

  setSelectedProyecto(proyecto: proyecto) {
    this.nothingSelect();
    this.selectedProyecto = proyecto;
  }

  getSelectedPlano() {
    return this.selectedPlano;
  }

  setSelectedPlano(plano: plano) {
    this.nothingSelect();
    this.selectedPlano = plano;
  }

  getSelectedZona() {
    return this.selectedZona;
  }

  setSelectedZona(zona: zona) {
    this.nothingSelect();
    this.selectedZona = zona;
  }

  getSelectedLuminaria() {
    return this.selectedLuminaria;
  }

  setSelectedLuminaria(luminaria: luminaria) {
    this.nothingSelect();
    this.selectedLuminaria = luminaria;
  }

  setSelectedLuminariaById(idLuminaria: string) {
    this.luminariaService.getByID(idLuminaria, false).subscribe((result: luminaria) => {
      this.setSelectedLuminaria(result);
    })
  }

}
